namespace TabAurous.Stock {
    export namespace JewelleryMovementService {
        export const baseUrl = 'Stock/JewelleryMovement';

        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<StockItemRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Stock/JewelleryMovement/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>JewelleryMovementService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
